import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const HERO_IMG = '/images/sidekicks/Interview-Coach.png';

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section id="hero" className="relative min-h-[100svh] flex items-end overflow-hidden">
      <img
        src={HERO_IMG}
        alt={t.hero.imageAlt}
        className="absolute inset-0 w-full h-full object-cover object-[center_20%] animate-ken-slow"
        width={1200}
        height={1500}
      />
      <div className="absolute inset-0 bg-hero-veil" aria-hidden />
      <div
        className="absolute inset-0 opacity-25 mix-blend-soft-light pixel-grid"
        aria-hidden
      />

      <div className="relative w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 pt-36 sm:pb-20 lg:pb-24">
        <p className="font-display font-bold text-mint-soft text-3xl sm:text-5xl lg:text-6xl tracking-tight animate-fade-up">
          Pixel Sidekicks
        </p>
        <h1 className="mt-4 max-w-3xl font-display font-bold text-white text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.12] tracking-tight text-balance animate-fade-up-delay">
          {t.hero.title}
        </h1>
        <p className="mt-5 max-w-xl text-lg sm:text-xl text-white/80 leading-relaxed animate-fade-up-late">
          {t.hero.lead}
        </p>

        <div className="mt-9 flex flex-col sm:flex-row gap-3 animate-fade-up-late">
          <a
            href="/s"
            className="inline-flex items-center justify-center gap-2 bg-ember hover:bg-ember-deep text-white px-8 py-4 font-bold text-base transition-colors"
          >
            {t.hero.ctaPrimary}
            <ArrowRight className="w-5 h-5" />
          </a>
          <a
            href="#sidekicks"
            className="inline-flex items-center justify-center gap-2 border border-white/35 hover:border-white/70 text-white px-8 py-4 font-semibold text-base transition-colors"
          >
            {t.hero.ctaSecondary}
          </a>
        </div>

        <p className="mt-8 max-w-2xl text-xs text-white/55 leading-relaxed">{t.hero.legal}</p>
      </div>
    </section>
  );
};

export default Hero;
